import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Post from './Post';
import moment from 'moment';
import { getPost } from "../../functions/post"
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%"
        },

    }
}));
const ListPost = () => {

    const styles = useStyles();

    const [post, setPost] = useState([{ _id: "", title: "", image_urls: [], content: "", date: "", author: "" }]);
    const [last, setLast] = useState(null);

    useEffect(() => {
        getPost(last).then(res => {
            console.log(res)
            if (post[0]._id === "") {
                setPost(res);
            } else {
                setPost([...post, ...res])
            }

        })
    }, [last])

    const onScroll = () => {
        if (window.scrollY + document.documentElement.clientHeight > document.documentElement.scrollHeight - 1) {

            setLast(post[post.length - 1]._id)
            console.log("onScroll")
        }
    };

    useEffect(() => {
        console.log("add scroll")
        window.addEventListener("scroll", onScroll);
        return () => {
            console.log("remove scroll")
            window.removeEventListener("scroll", onScroll);
        };
    });




    return (
        <>
            <div>
                <h2>
                    설문 게시판
                </h2>
            </div>
            <div className={styles.container}>
                {post.length === 1 ? <CircularProgress /> : <>
                    {
                        post.map((item, index) => {
                            return <Post
                                key={index}
                                title={item.title}
                                content={item.content}
                                date={item.date}
                                deadline={item.deadline}
                                done={item.done}
                                comments={item.comments}
                                author={item.author}
                                author_info={item.author_info}
                                goal_participants={item.goal_participants}
                                participants={item.participants}
                                target={item.target}
                                with_prize={item.with_prize}
                                prize={item.prize}
                                num_prize={item.num_prize}
                                credit={item.credit}
                                num_credit={item.num_credit}

                            />
                        })
                    }
                </>
                }
            </div>
        </>
    );
};

export default ListPost;